import { render, staticRenderFns } from "./landing-page-video.vue?vue&type=template&id=257a4bbc&scoped=true&"
import script from "./landing-page-video.vue?vue&type=script&lang=js&"
export * from "./landing-page-video.vue?vue&type=script&lang=js&"
import style0 from "./landing-page-video.vue?vue&type=style&index=0&id=257a4bbc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257a4bbc",
  null
  
)

export default component.exports